import { useContext } from 'react';

import { HistogramXScale } from '../contexts/HistogramXScale.context.js';

export const useHistogramXScale = () => {
  const context = useContext(HistogramXScale);
  if (context === undefined) {
    throw new Error('useHistogramXScale must be used within a HistogramXScale');
  }

  return context;
};
